import { ReportConfigurationsState } from "@idw-types/state/report-configurations-state";
import { ReportConfigurationsActionTypes, ReportConfigurationsActions } from "../actions/report-configurations-actions";

export const initialReportConfigurationsState: ReportConfigurationsState = {
    reportConfigurations: {
        data: null,
        isLoading: false
    }
}

export const reportConfigurationsReducer = (
    state: ReportConfigurationsState = initialReportConfigurationsState,
    action: ReportConfigurationsActions
): ReportConfigurationsState => {
    switch (action.type) {
        // Relying Parties
        case ReportConfigurationsActionTypes.SET_REPORT_CONFIGURATIONS_LOADING:
            return {
                ...state,
                reportConfigurations: {
                    ...(action.payload.isLoading
                        ? { ...initialReportConfigurationsState.reportConfigurations }
                        : { ...state.reportConfigurations }),
                    isLoading: action.payload.isLoading
                }
            };
        case ReportConfigurationsActionTypes.SET_REPORT_CONFIGURATIONS:
            return {
                ...state,
                reportConfigurations: {
                    data: action.payload.reportConfigurations,
                    isLoading: false
                }
            };
        default:
            return state;
    }
};